import Vue from 'vue'
import VueMeta from 'vue-meta'
import App from './App'
import router from './router'
// export for others scripts to use

Vue.config.productionTip = false

Vue.use(VueMeta)

/* eslint-disable no-new */
const _vue = new Vue({
  el: '#app',
  router,
  render: h => h(App)
})

window._vuePrerender = _vue



// WEBPACK FOOTER //
// ./src/main.js